/*
  AE: "Save $X" badge on Convermax product cards (collection, search, related products).
  Convermax renders its cards client-side from a template in its own dashboard, so the theme
  can't add markup to them. This reads each card's sale and compare-at prices and puts the
  same slanted tag the product page uses in the image's upper-left corner.

  Savings round DOWN to whole dollars (the product page and Horizon card badge do the same),
  so the badge never claims more than the real saving; under $1 shows nothing.
  Loaded from snippets/stylesheets.liquid (line marked "AE:"). Styles: ae-imm.css section 29.
*/
(() => {
  const toNumber = (el) => {
    const digits = (el?.textContent || '').replace(/[^0-9.]/g, '');
    return digits ? parseFloat(digits) : NaN;
  };

  const badge = (card) => {
    const media = card.querySelector('.cm_product-item__image-container');
    if (!media) return;
    const compare = card.querySelector('.cm_product-item__price_compare');
    const price = card.querySelector('.cm_product-item__price:not(.cm_product-item__price_compare)');
    const saving = compare && price ? Math.floor(toNumber(compare) - toNumber(price)) : 0;
    let tag = media.querySelector('.ae-cm-save');

    if (saving >= 1) {
      const text = `Save $${saving.toLocaleString('en-US')}`;
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'ae-cm-save';
        media.appendChild(tag);
      }
      if (tag.textContent !== text) tag.textContent = text;
    } else if (tag) {
      tag.remove();
    }
  };

  let queued = false;
  const scan = () => {
    queued = false;
    document.querySelectorAll('.cm_product-item').forEach(badge);
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  };

  // Convermax re-renders on filters, sorting and infinite scroll
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queue);
  } else {
    queue();
  }
})();
